/**
 * Widget embutível — por defeito a API é o mesmo host de onde `widget.js` foi carregado
 * (não o domínio da LP). Opcional: `apiBaseUrl` ou `VITE_APP_URL` no build como fallback.
 * Com `useMock: true` mantém dados locais (sem chamadas à API).
 *
 * <div id="decola-widget"></div>
 * <script src="https://unisinos.decolaedu.com/assets/js/widget.js"></script>
 * <script>
 *   DecolaWidget.init({
 *     container: '#decola-widget',
 *     offerId: '1;43827;1583',
 *     sellerId: 'sll_7890',
 *     campaignId: 'cmp_2026_lp01',
 *     themeId: '1',
 *     // apiBaseUrl: 'https://outro.com', // só se API ≠ origem do script
 *     // useMock: true,
 *   });
 * </script>
 */

import { createMockWidget } from './widgetMockRuntime';
import { createProductionWidget } from './widgetProductionRuntime';
import type { DecolaWidgetInitOptions } from './widgetTypes';
import { resolveWidgetApiBase } from './widgetApiBase';

export type { DecolaWidgetInitOptions };

const DecolaWidget = {
    init(options: DecolaWidgetInitOptions): void {
        const { container, offerId, sellerId, campaignId, themeId, useMock, apiBaseUrl } = options;
        const resolvedBase = resolveWidgetApiBase(apiBaseUrl);
        if (useMock) {
            createMockWidget(container, {
                container,
                offerId,
                sellerId,
                campaignId,
                themeId,
                useMock: true,
                apiBaseUrl: resolvedBase,
            });
            return;
        }
        void createProductionWidget(container, {
            container,
            offerId,
            sellerId,
            campaignId,
            themeId,
            useMock: false,
            apiBaseUrl: resolvedBase,
        });
    },
};

export default DecolaWidget;

if (typeof window !== 'undefined') {
    (window as unknown as { DecolaWidget: typeof DecolaWidget }).DecolaWidget = DecolaWidget;
    document.addEventListener('DOMContentLoaded', () => {
        const auto = document.querySelector('[data-decola-widget]');
        if (auto) {
            const offerId = (auto.getAttribute('data-offer-id') || '').trim() || 'mock';
            const themeId = (auto.getAttribute('data-theme-id') || '').trim() || '1';
            const sellerId = (auto.getAttribute('data-seller-id') || '').trim() || '';
            const campaignId = (auto.getAttribute('data-campaign-id') || '').trim() || '';
            const useMockAttr = (auto.getAttribute('data-use-mock') || '').trim().toLowerCase();
            const useMock = useMockAttr === 'true' || useMockAttr === '1';
            const apiBaseAttr = (auto.getAttribute('data-api-base-url') || '').trim();
            DecolaWidget.init({
                container: auto,
                offerId,
                sellerId,
                campaignId,
                themeId,
                useMock,
                apiBaseUrl: apiBaseAttr || undefined,
            });
        }
    });
}
